import { SideNav, SideNavContent } from "components";
import PageHeader from "components/UniversalComponents/PageHeader";
import { HeaderDasNew, MainBody, OverlayLoader, Ptag } from "components/core";
import React, { useEffect, useState } from "react";
import ClaimDetail from "../components/ClaimDetail";
import { useLocation } from "react-router";
import http from "services/httpService";
import { DetailedRow, DetailedTable } from "./style";
import { WidthLimiter } from "pages/PlanSetup/styles";
import { formatToRupees } from "utlis/utils";
import { startCase, toLower } from "lodash";

function EmployeeDetail() {
  const [loading, setLoading] = useState(true);
  const { pathname } = useLocation();
  const companyName = localStorage.getItem("company_name");
  const [tableData, setTableData] = useState();
  useEffect(async () => {
    try {
      const payload = pathname.split("/").pop();
      const { data } = await http.get("/business/get_claims_employee_data/", {
        params: {
          row_id: payload,
        },
      });
      setTableData(data);
      setLoading(false);
    } catch (e) {
      console.log(e);
    }
  }, []);

  return (
    <>
      {loading ? (
        <OverlayLoader />
      ) : (
        <>
          <SideNav>
            <SideNavContent />
          </SideNav>
          <HeaderDasNew company_name={companyName} />

          <MainBody>
            <PageHeader header="Claim Details" prev_page />
            <WidthLimiter style={{ paddingLeft: "12px" }}>
              <DetailedTable>
                {tableData?.map(({ name, value }) => {
                  // Skip rendering the "Balance Sum Insured" row if there's no value
                  if (name === "Balance Sum Insured" && (!value || value === "0")) {
                    return null;
                  }

                  const wordsToCapitalize = [
                    "Employee Name",
                    "Patient Name",
                    "Hospital Name",
                    "Hospital City",
                    "Hospital State",
                    "Claim Type",
                    "Claim Status",
                  ];
                  if (wordsToCapitalize.includes(name)) {
                    value = startCase(toLower(value));
                  }

                  return (
                    <tr key={name}>
                      <DetailedRow style={{ width: "30%" }}>
                        <Ptag fontWeight="500" fontSize="14px">
                          {name}
                        </Ptag>
                      </DetailedRow>
                      {value && value !== "0" ? (
                        <DetailedRow>
                          <Ptag fontWeight="500" fontSize="14px">
                            {[
                              "Sum Insured",
                              "Claim Amount",
                              "Balance Sum Insured",
                              "Paid Amount",
                            ].includes(name)
                              ? formatToRupees(value)
                              : value}
                          </Ptag>
                        </DetailedRow>
                      ) : (
                        <DetailedRow>
                          <Ptag fontWeight="600" fontSize="14px">
                            -
                          </Ptag>
                        </DetailedRow>
                      )}
                    </tr>
                  );
                })}
              </DetailedTable>
            </WidthLimiter>
          </MainBody>
        </>
      )}
    </>
  );
}

export default EmployeeDetail;
